import React, { useState, useEffect } from "react";
import { BuildIcon } from "../../../constants/icons";
import { STEP_STATUS } from "../../../constants/enamerations";
import JobImageGallery from "./JobImageGallery";
import {getJobQAStepsQuestionsImages} from "../../../shared/helpers";


const ThumbnailImage = ({ image, remaining }) => (
    <div style={{ position: "relative",borderRadius: 8, overflow: 'hidden',marginRight: remaining ? 0 : 10, }}>
      <img
          alt={`thumbnail-${image.index}`}
          src={image.public_url}
          style={{ maxWidth: "60px" }}
      />
      {remaining && (
          <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                color: "#ffffff",
                fontWeight: "800",
                fontSize: 17,
              }}
          >
            +{remaining}
          </div>
      )}
    </div>

);

const QACard = ({ job }) => {
  const [questions, setQuestions] = useState(null);

  useEffect(() => {
    job && setQuestions(job.questions);
  }, [job]);


  return (
    questions &&
    questions.map((item, index) =>
        <tr key={index}>
          <td>
            <div style={{borderLeft: `4px solid ${item.status && STEP_STATUS[item.status].color}`,}}
                 className="question_card_wrapper">
              <div className="left_container">
                <h5 style={{fontWeight:'bold'}}>QUESTION {index + 1}</h5>
                {item.text &&  <p className={"question_info"}>{item.text}</p>}
                {item.status && <div className={"question_status"}>
                  {STEP_STATUS[item.status].icon}&nbsp;{" "}
                  {STEP_STATUS[item.status].label}
                </div>}
              </div>
              <div className={'right_container'}>
                <div className={'image_container'}>
                  {item.assets.slice(0,3).map((image, imageIndex) => {
                    return< ThumbnailImage
                        key={`thumbnail-${imageIndex}`}
                        image={{ ...image, index: imageIndex }}
                    />
                  })}
                  {item.assets.length > 3 ? <div>
                    <ThumbnailImage
                        key={`thumbnail-${3}`}
                        image={{ ...item.assets[3], index: 3 }}
                        remaining={item.assets.length-3}
                    />
                  </div> : null}
                </div>
                <div className={'comment_container'}>
                  <p>{item.pm_comment ? item.pm_comment : ""}</p>
                </div>
              </div>
            </div>
          </td>
        </tr>
    )
  );
};

const StepsForPrint = ({ job }) => {
  return (
    <div className="d-flex flex-column">
      <div className="print_wrapper w-100">
        <div className="print_header">
          <div className="logo_header">
            <img
              className="pdfLogoimage"
              src={require("../../../shared/img/logo/pdfLogo.png")}
              alt={"logo"}
            />
          </div>
          <div className="contact_header">
            <p>020 3909 8880</p>
            <p>info@londonmep.co.uk</p>
          </div>
        </div>
        <div className="body_wrapper">
          <div className="project_build_wrapper">
            <div className="project_info">
              <div className="d-flex align-items-center">
                <BuildIcon /> &nbsp; {job && job.project.name}
              </div>
              <h1>{job && job.description}</h1>
            </div>
            <div className="build_info">
              <div className="pr-5 w-50 d-flex flex-column justify-content-between">
                <div className="mb-2 d-flex justify-content-between">
                  <p className="dim">Level</p>
                  <span>{job && job.level.name}</span>
                </div>
                <div className="mt-2 d-flex justify-content-between">
                  <p className="dim">Block</p>
                  <span>{job && job.block.name}</span>
                </div>
              </div>
              <div className="pl-5 w-50 d-flex flex-column justify-content-between">
                <div className="mb-2 d-flex justify-content-between">
                  <p className="dim">Unit type</p>
                  <span>{job && job.unit_type}</span>
                </div>
                <div className="mt-2 d-flex justify-content-between">
                  <p className="dim">Unit ID</p>
                  <span>{job && job.plot.name}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="analytic_wrapper">
            <div className="analytic_item">
              <div className="name">SCORE</div>
              <div className="scope">100%</div>
            </div>
            <div className="analytic_item">
              <div className="name">FAILED ITEMS</div>
              <div className="scope">0%</div>
            </div>
            <div className="analytic_item">
              <div className="name">ACTIONS</div>
              <div className="scope">0%</div>
            </div>
          </div>

          <div className="inspection_wrapper">
            <h3>INSPECTION INFORMATION</h3>

            <div className="inspection_information">
              <div className="inspection_item">
                <div className="mb-3 w-100 d-flex justify-content-between">
                  <p className="dim">Conducted on</p>
                  <span>
                    {job &&
                      job.completed_at &&
                      new Date(job.completed_at).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                  </span>
                </div>
                <div className="w-100 d-flex justify-content-between">
                  <p className="dim">Inspection by</p>
                  <span>
                    {job && job.qa && job.qa.first_name + " " + job.qa.surname}
                  </span>
                </div>
                {job && job.employee && job.employee.first_name &&
                    <div className="w-100 d-flex justify-content-between">
                  <p className="dim">Works conducted by</p>
                  <span>
                     {`${job.employee.first_name} ${!!job.employee.surname ? job.employee.surname : ''}`.trim()}
                  </span>
                </div>}

              </div>
              <div className="inspection_item">
                <div className="mb-3 w-100 d-flex justify-content-between">
                  <p className="dim">Main Contractor/Client</p>
                  <span>{job && job.project && job.project.client}</span>
                </div>
                <div className="w-100 d-flex justify-content-between">
                  <p className="dim">Document No.</p>
                  <span>{job && job.qa_audit_reference}</span>
                </div>
              </div>
            </div>

            <p>
              Please take note that all the information in this document is to
              remain private and confidential.
            </p>
          </div>
        </div>
      </div>
      <table className="w-100">
        <thead>
          <tr>
            <th>
              <br />
            </th>
          </tr>
        </thead>
        <tbody className="w-100">
          <QACard job={job} />
        </tbody>
      </table>
      <JobImageGallery groupedImages={getJobQAStepsQuestionsImages(job)}/>
    </div>
  );
};

export default StepsForPrint;
